import { render, staticRenderFns } from "./editClass.vue?vue&type=template&id=374e9061&"
import script from "./editClass.vue?vue&type=script&lang=js&"
export * from "./editClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports